/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Placeholder_Signup_EmailInputs */



/**
* | output |
* | --- |
* | "Enter your email" |
*
* @param {Login_Placeholder_Signup_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_placeholder_signup_email = /** @type {((inputs?: Login_Placeholder_Signup_EmailInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Placeholder_Signup_EmailInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez votre email")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese su correo electrónico")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Digite seu e-mail")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci la tua email")
	return /** @type {LocalizedString} */ ("Enter your email")
});